import React, { Reducer, Dispatch } from 'react';
import { Config } from './config';
import { Auth } from './services/auth.service';
import { DirectBankingMiddlewareApi } from './services/directBankingMiddlewareApi.service';

const config = new Config();
type Data = {
  initializing: boolean;
  isSignedIn: boolean;
  userEmail: string | undefined;
  isAdmin: boolean;
  isConsumer: boolean;
  consumerId: string
};

export type Context = {
  data: Data;
  setData: Dispatch<Partial<Data>>
};

const RevoluadminContext = React.createContext<Context | undefined>(undefined);


export function useDirectBankingMiddlewareApi(): DirectBankingMiddlewareApi {
  const context = React.useContext(RevoluadminContext);
  if (context === undefined) {
    throw new Error('Use api must be used inside of RevoluadminProvider');
  }
  return new DirectBankingMiddlewareApi(config, new Auth(config, context));
}

export function useAuth(): Auth {
  const context = React.useContext(RevoluadminContext);
  if (context === undefined) {
    throw new Error('Use api must be used inside of RevoluadminProvider');
  }
  return new Auth(config, context);
}

export function useContext(): Context {
  const context = React.useContext(RevoluadminContext);
  if (context === undefined) {
    throw new Error('Use Store must be used inside of RevoluadminProvider');
  }
  return context;
}

export const RevoluadminProvider = ({ children }: { children: any }) => {
  const reducer: Reducer<Data, Partial<Data>> = (state: Data, action: Partial<Data>) => {
    return {
      ...state,
      ...action
    };
  }

  const [data, setData] = React.useReducer(
    reducer,
    {
      initializing: true,
      isSignedIn: false,
      userEmail: undefined,
      isAdmin: false,
      isConsumer: false,
      consumerId: ''
    }
  );

  return (
    <RevoluadminContext.Provider value={{ data, setData }}>
      {children}
    </RevoluadminContext.Provider>
  )
}
